import Vue from 'vue';
import _store from './store';
import App from './App.vue';
import {Plugin} from 'vue-fragment';

Vue.use(Plugin);

window.initPage = (el, config) => {
	new Vue({
		el: el,
		store: _store(config),
		render: h => h(App)
	})
};
